export class PaginationModel {
    constructor() {
        this.EndCursor = "";
        this.HasNextPage = undefined;
        this.Row = 50;
    }
}